export default __webpack_public_path__ + "static/media/inam.4aa98251.jpg";